export default [
  {
    path: "/perfis",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "perfis_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "perfis", to: "perfis_list" }],
          permission: "perfis:edit",
          title: "Perfil - Edição"
        }
      }
    ]
  }
];
